import { UsersThree, ChatsCircle, Phone, Bookmark, Airplane, Confetti, Camera, TennisBall } from "@phosphor-icons/react";

const INTAKE_URL = "/intake";

const addOns = [
  {
    id: "friend",
    icon: UsersThree,
    name: "Train With a Friend",
    desc: "Bring a workout buddy onto your plan at a discounted rate. Same custom programming, shared accountability, double the dopamine.",
    tag: "Popular",
  },
  {
    id: "messaging",
    icon: ChatsCircle,
    name: "Extra Messaging Support",
    desc: "Unlimited messaging access between check-ins. Faster replies, deeper coaching conversations, real-time form-check chats.",
    tag: null,
  },
  {
    id: "strategy",
    icon: Phone,
    name: "1:1 Strategy Call",
    desc: "60-minute deep-dive call. Goal mapping, plan-building, accountability framework. Great as a one-off or quarterly reset.",
    tag: null,
  },
  {
    id: "meal",
    icon: Bookmark,
    name: "Custom Macro Build",
    desc: "Personalized macro &amp; habit blueprint based on your goals, body, schedule, and travel pattern. Refreshed quarterly if needed.",
    tag: null,
  },
  {
    id: "event",
    icon: Confetti,
    name: "Event Prep Boost",
    desc: "Wedding, photoshoot, vacation, reunion, race? An accelerated training + recovery block built around your event date.",
    tag: "Wedding-ready",
  },
  {
    id: "travel",
    icon: Airplane,
    name: "Travel Week Programming",
    desc: "Hotel-room, bodyweight, or boutique-gym friendly workouts for the weeks you're on the road. Built around your itinerary.",
    tag: null,
  },
  {
    id: "form",
    icon: Camera,
    name: "Form Review Pack",
    desc: "Send lift videos, get back voice-noted feedback within 48 hours. Add it any time you're hitting a sticking point.",
    tag: null,
  },
  {
    id: "sport",
    icon: TennisBall,
    name: "Sport Sharpen Block",
    desc: "Pickleball, golf, or rec-league season prep. Strength, mobility & conditioning programming built around your sport — so you don't just play, you perform.",
    tag: "Hobby-friendly",
  },
];

export default function AddOns() {
  return (
    <section
      id="add-ons"
      data-testid="addons-section"
      className="relative px-6 md:px-12 lg:px-20 py-16 lg:py-20 border-b border-white/10"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#FF1B91]" />
            <p className="text-[11px] uppercase tracking-[0.4em] text-[#FF1B91] font-semibold">Add It On / 04</p>
          </div>
          <h2 className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.9] tracking-tighter">
            Build it{" "}
            <span className="font-brush font-normal normal-case text-[#FF1B91] inline-block transform -rotate-2">your way.</span>
          </h2>
        </div>
        <p className="md:max-w-sm text-white/70 leading-relaxed">
          Stack any of these onto an Essentials, Coaching, or VIP plan whenever you need it. Pricing &amp; details quoted in your intake.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 max-w-7xl mx-auto">
        {addOns.map((a) => {
          const Icon = a.icon;
          return (
            <div
              key={a.id}
              data-testid={`addon-${a.id}`}
              className="group relative border border-white/10 bg-[#0F0F0F] hover:border-[#FF1B91] hover:bg-[#141414] transition-all p-6 flex flex-col"
            >
              {a.tag && (
                <span className="absolute top-4 right-4 text-[9px] uppercase tracking-[0.2em] bg-[#FF1B91] text-white px-2 py-1 font-bold">
                  {a.tag}
                </span>
              )}
              <div className="w-11 h-11 border border-white/15 flex items-center justify-center group-hover:border-[#FF1B91] group-hover:text-[#FF1B91] transition-colors mb-5">
                <Icon size={20} weight="bold" />
              </div>
              <h3 className="font-body font-semibold text-xl tracking-tight mb-3 leading-snug">{a.name}</h3>
              <p className="text-sm text-white/70 leading-relaxed mb-5 flex-1">{a.desc}</p>
              <div className="border-t border-white/10 pt-4 flex items-center justify-between">
                <span className="text-[10px] uppercase tracking-[0.25em] text-white/45 font-semibold">Add in your intake</span>
                <span className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#FF1B91]/70">
                  ✦
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-12 text-center max-w-2xl mx-auto">
        <p className="text-white/60 text-sm">
          Note all desired add-ons inside your Sweat With Slay intake form — final pricing is quoted based on your full plan and selected add-ons.
        </p>
      </div>
    </section>
  );
}
